import React from 'react';
import { useShutdownAccesses } from '../../../../../shared/lib/hooks/useShutdownAccesses';
import ListCellContent from '../../../../../shared/ui/ListCellContent/ListCellContent';
import { shutdownInitiatorsQuery } from '../../../../../shared/api/queries';
import Item from './components/Item/Item';
import styles from './Content.module.scss';
import ChangeEntity from './components/ChangeEntity/ChangeEntity';

const { useShutdownInitiators } = shutdownInitiatorsQuery;

const getItems = (items) =>
  items?.length ? items : [{ id: 0, name: 'Не указаны' }];
const getSortItems = (items) =>
  items?.length ? items.sort((a, b) => b.isMain - a.isMain) : [];

const TooltipItem = ({ item, parentWidth }) => (
  <Item
    item={item}
    parentWidth={parentWidth}
    style={{ color: !!item?.isMain && '#0995ed' }}
  />
);

const ActiveInitiators = ({ shutdown, rowExpanded = false }) => {
  const itemsAmount = shutdown.initiators?.length || 0;
  const cityId = shutdown.alertCity?.id;

  const { data } = useShutdownInitiators(cityId, {
    staleTime: Infinity,
    enabled: Boolean(rowExpanded && cityId),
  });

  const showAddBtn = rowExpanded && itemsAmount < data?.length;

  return (
    <>
      <ListCellContent
        className={styles.root}
        items={getItems(getSortItems(shutdown.initiators))}
        renderItem={({ item, parentWidth }) => (
          <TooltipItem
            item={item}
            parentWidth={parentWidth}
          />
        )}
      />
      {showAddBtn && <ChangeEntity shutdown={shutdown} />}
    </>
  );
};

const Content = ({ shutdown, rowExpanded }) => {
  const { canChange } = useShutdownAccesses();

  if (!canChange) {
    return (
      <ListCellContent
        className={styles.root}
        items={getItems(getSortItems(shutdown.initiators))}
        renderItem={({ item, parentWidth }) => (
          <TooltipItem
            item={item}
            parentWidth={parentWidth}
          />
        )}
      />
    );
  }

  return (
    <ActiveInitiators
      shutdown={shutdown}
      rowExpanded={rowExpanded}
    />
  );
};

export default Content;
